export const userActions = {
  userCreated: "User created successfully",
  userUpdated: "User updated successfully"
};
